import { VHost } from '@plek-projects/shared-resources/New';
import { merge } from 'lodash';

export const DEFAULT_VHOST: Partial<VHost.VHostFrontend> = {
	sitename: 'Plek',
	themecolor: '#3b97a4',
	theme: {
		logoLarge: '/images/plek-logo.png',
		background: {
			login: {
				path: '/images/plek-bg.png',
				backgroundColor: '#f3f3f3',
			},
		},
	},
};

export const MERGED_VHOST = merge({}, DEFAULT_VHOST, window.vhostObj || {});
